<div class="mobile-warning-container">
  <div class="glass-card">
    <div class="icon-section">
      <div class="monitor-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="desktop-icon">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y1="21"></line>
          <line x1="12" y1="17" x2="12" y1="21"></line>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="restricted-icon">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
        </svg>
      </div>
    </div>

    <div class="content-section">
      <h1>Module Not Accessible</h1>
      <p class="subtitle">This module is currently optimized for desktop viewing only.</p>

      <div class="divider"></div>

      <p class="instruction">
        For the best experience, please switch to a <strong>Desktop device</strong>.
      </p>

      <!-- <div class="features-list">
        <div class="feature-item">
          <span class="dot"></span> Full Screen Dashboard
        </div>
        <div class="feature-item">
          <span class="dot"></span> Advanced Data Controls
        </div>
        <div class="feature-item">
          <span class="dot"></span> Interactive Reports
        </div>
      </div> -->
    </div>

    <!-- <div class="footer-note">
      We're working on making this accessible soon.
    </div> -->
  </div>
</div>